var pubnub = PUBNUB({
	publish_key: 'pub-c-ac049dfa-b211-47d2-bd58-d140c4faebae',
	subscribe_key: 'sub-c-0da88b20-02a5-11e6-a492-02ee2ddab7fe'
});

module.exports = pubnub;



/** WEBPACK FOOTER **
 ** ./src/helper/Pubnub.js
 **/